import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useQuickMessagesApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getAll: () => apiFetch("/quickMessages"),

      getById: (id) => apiFetch(`/quickMessages/${id}`),

      create: (formData) =>
        apiFetch("/quickMessages", {
          method: "POST",
          body: formData,
        }),

      update: (id, formData) =>
        apiFetch(`/quickMessages/${id}`, {
          method: "PUT",
          body: formData,
        }),

      remove: (id) =>
        apiFetch(`/quickMessages/${id}`, {
          method: "DELETE",
        }),
    }),
    [apiFetch],
  );
}
